import React from 'react';
import { Icon } from '@upsales/components';
import history from 'App/pages/routes/history';
import T from 'Components/Helpers/translate';
import { useSoftDeployAccess } from 'App/components/hooks';

type Props = {
	query: string;
	closeSearch: () => void;
};

const SupersearchAIActions = ({ query, closeSearch }: Props) => {
	const t = T;
	const trimmed = query.trim();
	const hasQuickSearchAi = useSoftDeployAccess('QUICK_SEARCH_AI');

	if (!hasQuickSearchAi) {
		return null;
	}

	if (trimmed.length === 0) {
		return null;
	}

	const handleClick = () => {
		closeSearch();
		history.push(`/ai-workspace?q=${encodeURIComponent(trimmed)}`);
	};

	return (
		<button
			type="button"
			className="supersearch-ai-actions"
			onClick={handleClick}
			data-test-id="supersearch-ai-chat"
		>
			<Icon name="magic" />
			<span className="supersearch-ai-actions__label">
				{t('navbar.quickSearch.ai.chatAbout', { query: trimmed })}
			</span>
		</button>
	);
};

export default SupersearchAIActions;
